import { render, staticRenderFns } from "./GoldSchemelist.vue?vue&type=template&id=48bbd24e&"
import script from "./GoldSchemelist.vue?vue&type=script&lang=js&"
export * from "./GoldSchemelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports